import { createAction } from 'redux-act'

//State
export const getAccountingRequests = createAction('Get Accounting Requests')
export const getAccountingRequestsSuccessful = createAction('Get Accounting Requests Success')
export const getAccountingRequestsFailure = createAction('Get Accounting Requests Fail')

export const accountingRequestConfirm = createAction('Accounting Request Confirm')
export const accountingRequestConfirmSuccessful = createAction('Accounting Request Confirm Success')
export const accountingRequestConfirmFailure = createAction('Accounting Request Confirm Fail')

export const accountingRequestCancel = createAction('Accounting Request Cancel')
export const accountingRequestCancelSuccessful = createAction('Accounting Request Cancel Success')
export const accountingRequestCancelFailure = createAction('Accounting Request Cancel Fail')

export const confirmAllCost = createAction('Confirm All Cost')
export const confirmAllCostSuccessful = createAction('Confirm All Cost Success')
export const confirmAllCostFailure = createAction('Confirm All Cost Fail')

//Operation
export const setFilter = createAction('Set Filter')
